var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "head-menu-container" },
    [
      _c(
        "el-menu",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          staticClass: "el-menu-head",
          attrs: {
            "default-active": _vm.activeMenu,
            router: true,
            "background-color": _vm.variables.headMenuBg,
            "text-color": _vm.variables.headMenuText,
            "active-text-color": _vm.variables.headMenuActiveText,
          },
          on: { select: _vm.handleSelectMenu },
        },
        [
          _vm._l(_vm.permission_routes, function (route) {
            return [
              !route.hidden
                ? _c(
                    "el-menu-item",
                    { key: route.path, attrs: { index: route.path } },
                    [_vm._v(_vm._s(route.meta && route.meta.title))]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }